import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createStore, applyMiddleware, compose, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { serverSide } from 'libs/utils/environment';
import { bridgeReduxToBackboneEvents } from 'libs/utils/backbone';
import { logError } from 'libs/utils/window';
import { staticReducers } from './reducers';
import { getStaticSagas } from './sagas';
let globalStore;
export function createReducers(reducers) {
  return combineReducers(_objectSpread(_objectSpread({}, staticReducers), reducers));
}

const crashReporter = () => next => action => {
  try {
    return next(action);
  } catch (err) {
    logError(err, {
      extra: typeof action.type === 'string' ? action.type : 'unknown'
    });
    throw err;
  }
};

const handleSagaError = (error, errorInfo) => {
  logError(error, {
    extra: "redux-saga: ".concat(errorInfo.sagaStack)
  });
};

export function configureStore(initialState, reducer) {
  let sagas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let enhancer;
  const middleware = [];
  const sagaMiddleware = createSagaMiddleware({
    onError: handleSagaError
  });
  const development = false;
  middleware.push(sagaMiddleware);

  if (development) {
    const reduxDevTools = !serverSide && // Airbnb config allows only window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

    /* eslint-disable no-underscore-dangle */
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
    /* eslint-enable */


    enhancer = compose(applyMiddleware(...middleware), reduxDevTools || compose);
  } else {
    enhancer = applyMiddleware(...middleware, crashReporter);
  }

  const store = createStore(reducer, initialState, enhancer);
  const sagaRun = sagaMiddleware.run(function* rootSaga() {
    yield all([...getStaticSagas(), ...sagas]);
  });
  return {
    store,
    sagaRun
  };
}
export function initStore(props, railsContext, reducers, sagas) {
  const initialState = _objectSpread({
    railsContext
  }, props); // When react is reloaded via react:reload event, ReactOnRails tries to initialize the store
  // again, which is not what we want. Instead, we grab the already existing one.


  if (globalStore) return globalStore;
  globalStore = configureStore(initialState, createReducers(reducers), sagas).store;
  bridgeReduxToBackboneEvents(globalStore);
  return globalStore;
}